/* -------------------------------------------------------------------------- */
/*  Perspectivas ASOFOM — Editorial articles data                              */
/* -------------------------------------------------------------------------- */

export const CATEGORIES = [
  { slug: 'innovacion-financiera', label: { es: 'Innovación financiera', en: 'Financial Innovation' }, color: '#FF6B35' },
  { slug: 'fondeo-mercados', label: { es: 'Fondeo y mercados', en: 'Funding & Markets' }, color: '#1B3A5F' },
  { slug: 'riesgo-cartera', label: { es: 'Riesgo y cartera', en: 'Risk & Portfolio' }, color: '#8B1A1A' },
  { slug: 'tecnologia-ia', label: { es: 'Tecnología e IA', en: 'Tech & AI' }, color: '#0F766E' },
  { slug: 'regulacion-cumplimiento', label: { es: 'Regulación y cumplimiento', en: 'Regulation & Compliance' }, color: '#6B21A8' },
  { slug: 'inclusion-financiera', label: { es: 'Inclusión financiera', en: 'Financial Inclusion' }, color: '#1E40AF' },
  { slug: 'sostenibilidad-asg', label: { es: 'Sostenibilidad y ASG', en: 'Sustainability & ESG' }, color: '#15803D' },
  { slug: 'credito-financiamiento', label: { es: 'Crédito y financiamiento empresarial', en: 'Business Credit & Financing' }, color: '#B45309' },
  { slug: 'liderazgo-talento', label: { es: 'Liderazgo y talento', en: 'Leadership & Talent' }, color: '#9333EA' },
  { slug: 'tendencias-sofom', label: { es: 'Tendencias del sector SOFOM', en: 'SOFOM Sector Trends' }, color: '#0E7490' },
];

/* -------------------------------------------------------------------------- */
/*  ARTICLES                                                                  */
/* -------------------------------------------------------------------------- */
export const ARTICLES = [
  {
    slug: 'asi-se-vivio-la-20-convencion-nacional-asofom',
    categorySlug: 'tendencias-sofom',
    featured: true,
    publishedAt: '2026-08-29',
    readingMinutes: 4,
    author: { name: 'Equipo ASOFOM', role: 'Redacción institucional' },

    title: {
      es: 'Así se vivió la 20ª Convención Nacional ASOFOM: tres días que hicieron historia en Cancún',
      en: 'This is how the 20th ASOFOM National Convention was lived: three history-making days in Cancún',
    },
    subtitle: {
      es: 'Más de 800 asistentes, más de 60 speakers y una comunidad que demostró que el legado nos une y el futuro nos mueve. Esta es la crónica de una edición que rompió todos los récords.',
      en: 'Over 800 attendees, more than 60 speakers and a community that proved the legacy unites us and the future moves us. This is the chronicle of a record-breaking edition.',
    },

    seo: {
      metaTitle: 'Así se vivió la 20ª Convención Nacional ASOFOM 2026 | Perspectivas',
      metaDescription: 'Crónica de la 20ª Convención Nacional ASOFOM en Cancún: sold out total, +800 asistentes, +60 speakers y una comunidad que hizo historia. Revive los mejores momentos.',
      keyword: 'convención nacional asofom 2026',
      secondaryKeywords: [
        'resumen convención asofom',
        'comunidad asofom',
        'sector financiero no bancario méxico',
        'evento financiero cancún 2026',
      ],
    },

    cover: {
      image: 'https://images.weserv.nl/?url=customer-assets-lxgj4vgw.emergentagent.net/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/fkpqv7qy_WhatsApp%20Image%202026-08-28%20at%202.17.35%20PM.jpeg&w=1600&q=80&output=webp',
      alt: 'Momento de celebración en el escenario principal de la 20ª Convención Nacional ASOFOM en AVA Resort Cancún',
    },

    excerpt: {
      es: 'Del 26 al 28 de agosto, AVA Resort Cancún fue la casa de la comunidad financiera no bancaria más importante de México. Sold out total, negocios, amistades y una promesa: la 21ª será aún más grande.',
      en: 'From August 26–28, AVA Resort Cancún hosted Mexico\'s most important non-bank financial community. Total sold out, deals, friendships and a promise: the 21st will be even bigger.',
    },

    summary60s: {
      es: [
        'La 20ª Convención Nacional ASOFOM registró sold out total: más de 800 asistentes y más de 60 speakers en AVA Resort Cancún.',
        'Hubo de todo: carrera 5K al amanecer, paneles magistrales, Speed Dating de Fondeo, Live Cocktail Experience y The Grand Finale.',
        'ASOFOM confirmó que es más que una asociación: es una comunidad que hace negocios, celebra y construye el futuro del financiamiento junta.',
        'La 21ª Convención Nacional ya está en el horizonte: quien no estuvo, no puede volver a perdérsela.',
      ],
      en: [
        'The 20th ASOFOM National Convention was a total sold out: over 800 attendees and 60+ speakers at AVA Resort Cancún.',
        'It had everything: a 5K sunrise run, keynote panels, Funding Speed Dating, the Live Cocktail Experience and The Grand Finale.',
        'ASOFOM confirmed it is more than an association: a community that does business, celebrates and builds the future of financing together.',
        'The 21st National Convention is on the horizon: those who missed it cannot miss it again.',
      ],
    },

    sections: [
      {
        id: 'comunidad',
        h2: { es: 'Una comunidad, no solo un evento', en: 'A community, not just an event' },
        paragraphs: {
          es: [
            'Hay eventos que se miden en asistentes, y hay eventos que se miden en abrazos, acuerdos cerrados y reencuentros. La 20ª Convención Nacional ASOFOM fue de los segundos. Desde el registro del miércoles hasta el último acorde de The Grand Finale, Cancún respiró comunidad: fondeadores, SOFOMes, fintechs, reguladores y aliados compartiendo la misma mesa y la misma visión.',
            'El sold out total no fue casualidad. Fue la confirmación de 20 años de un legado construido a pulso por cientos de instituciones que creen que el financiamiento no bancario es motor del México productivo.',
          ],
          en: [
            'Some events are measured in attendees; others are measured in hugs, closed deals and reunions. The 20th ASOFOM National Convention was the latter. From Wednesday\'s check-in to the last chord of The Grand Finale, Cancún breathed community: funders, SOFOMs, fintechs, regulators and allies sharing the same table and the same vision.',
            'The total sold out was no accident. It confirmed 20 years of a legacy built by hundreds of institutions that believe non-bank financing drives productive Mexico.',
          ],
        },
      },
      {
        id: 'momentos',
        h2: { es: 'Del amanecer en la playa al escenario principal', en: 'From sunrise on the beach to the main stage' },
        paragraphs: {
          es: [
            'La comunidad corrió junta en la 5ª Carrera-Caminata al amanecer, negoció en las rondas de Speed Dating de Fondeo, aprendió en paneles y fireside chats con líderes del sector, y celebró en el Live Cocktail Experience y la Cena de Gala del 20 aniversario.',
            'La Ponencia Magistral de clausura y The Grand Finale pusieron el broche de oro a tres días donde cada espacio —del salón principal a la terraza— se convirtió en una oportunidad de conexión.',
          ],
          en: [
            'The community ran together at the 5th sunrise Run-Walk, negotiated in the Funding Speed Dating rounds, learned in panels and fireside chats with sector leaders, and celebrated at the Live Cocktail Experience and the 20th Anniversary Gala Dinner.',
            'The closing Keynote and The Grand Finale were the golden finish to three days where every space —from the main hall to the terrace— became an opportunity to connect.',
          ],
        },
      },
      {
        id: 'fomo',
        h2: { es: '¿No estuviste? Esto es lo que se siente perdérsela', en: 'Missed it? This is what missing it feels like' },
        paragraphs: {
          es: [
            'Los negocios que nacieron en un pasillo, la tarjeta que se escaneó en el Lead Scan, el consejo que un fundador le dio a otro frente al mar: nada de eso se puede repetir. Lo que sí se puede hacer es no volver a perdérselo.',
            'La buena noticia: ASOFOM no se detiene. Los capítulos regionales, los foros y Perspectivas mantienen viva la conversación todo el año. Y la 21ª Convención Nacional ya está en camino.',
          ],
          en: [
            'The deals born in a hallway, the card scanned on Lead Scan, the advice one founder gave another facing the sea: none of that can be repeated. What you can do is never miss it again.',
            'The good news: ASOFOM never stops. Regional chapters, forums and Perspectivas keep the conversation alive all year. And the 21st National Convention is already on its way.',
          ],
        },
      },
    ],

    faqs: [
      {
        q: { es: '¿Cuándo y dónde fue la 20ª Convención Nacional ASOFOM?', en: 'When and where was the 20th ASOFOM National Convention?' },
        a: {
          es: 'Se celebró del 26 al 28 de agosto de 2026 en AVA Resort Cancún, con formato all-inclusive y sold out total de asistentes y patrocinios.',
          en: 'It took place August 26–28, 2026 at AVA Resort Cancún, all-inclusive format, with a total sold out of attendees and sponsorships.',
        },
      },
      {
        q: { es: '¿Cuántas personas asistieron a la convención?', en: 'How many people attended the convention?' },
        a: {
          es: 'Más de 800 asistentes entre SOFOMes, fondeadores, fintechs, reguladores y aliados del sector, con más de 60 speakers en el programa.',
          en: 'Over 800 attendees including SOFOMs, funders, fintechs, regulators and sector allies, with more than 60 speakers on the program.',
        },
      },
      {
        q: { es: '¿Cuándo será la 21ª Convención Nacional ASOFOM?', en: 'When will the 21st ASOFOM National Convention be?' },
        a: {
          es: 'La sede y las fechas se anunciarán próximamente por los canales oficiales de ASOFOM. Los lugares de la 20ª edición se agotaron por completo, así que te recomendamos estar atento a la preventa.',
          en: 'The venue and dates will be announced soon through ASOFOM\'s official channels. The 20th edition sold out completely, so keep an eye on the presale.',
        },
      },
    ],

    relatedSlugs: ['como-esta-cambiando-el-sistema-financiero-mexicano', 'el-sistema-financiero-que-mexico-necesita'],
  },
  {
    slug: 'como-esta-cambiando-el-sistema-financiero-mexicano',
    categorySlug: 'innovacion-financiera',
    featured: false,
    publishedAt: '2026-06-24',
    readingMinutes: 6,
    author: { name: 'Equipo ASOFOM', role: 'Redacción institucional' },

    title: {
      es: 'Cómo está cambiando el sistema financiero mexicano: innovación, fintech y nuevas reglas',
      en: 'How Mexico\'s financial system is changing: innovation, fintech and new rules',
    },
    subtitle: {
      es: 'Fintechs, banca abierta, inteligencia artificial y nuevos modelos de colaboración están redefiniendo la competencia en el ecosistema financiero. Estas son las fuerzas que las SOFOMes, bancos y proveedores deberán entender para liderar la siguiente etapa.',
      en: 'Fintechs, open banking, AI and new collaboration models are redefining competition in the financial ecosystem.',
    },

    seo: {
      metaTitle: 'Cómo cambia el sistema financiero mexicano | ASOFOM',
      metaDescription: 'Fintech, IA, banca abierta e inclusión financiera están redefiniendo el sistema financiero mexicano. Conoce las tendencias que marcarán la agenda ASOFOM 2026.',
      keyword: 'cómo está cambiando el sistema financiero mexicano',
      secondaryKeywords: [
        'innovación financiera en México',
        'fintech en México',
        'futuro del sistema financiero mexicano',
        'inteligencia artificial en finanzas',
        'inclusión financiera en México',
        'nuevos jugadores financieros',
      ],
    },

    cover: {
      image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=1600&q=80&auto=format&fit=crop',
      alt: 'Transformación del sistema financiero mexicano mediante innovación, tecnología y nuevos modelos de colaboración',
    },

    excerpt: {
      es: 'La llegada de fintechs, banca abierta, inteligencia artificial y nuevos modelos de colaboración ha generado un ecosistema mucho más dinámico, competitivo y centrado en el usuario.',
      en: 'The arrival of fintechs, open banking, AI and new collaboration models has created a much more dynamic, competitive and user-centric ecosystem.',
    },

    /* ---------- "En 60 segundos" — quick takeaways ---------- */
    summary60s: {
      es: [
        'Las fintechs, la banca abierta y la inteligencia artificial están redefiniendo la competencia y elevando las expectativas del cliente final.',
        'La experiencia del cliente ya es tan determinante como el producto financiero en sí; las instituciones que no se adapten perderán relevancia.',
        'La inclusión financiera deja de ser un objetivo aspiracional y se convierte en un motor real de innovación y nuevos modelos de negocio.',
        'La colaboración entre SOFOMes, fintechs y proveedores tecnológicos sustituye a la competencia tradicional como vía para escalar.',
        'Las nuevas reglas del sector se discutirán en vivo en la 20ª Convención Nacional ASOFOM (26–28 agosto 2026, AVA Resort Cancún).',
      ],
      en: [
        'Fintechs, open banking and AI are redefining competition and raising customer expectations.',
        'Customer experience is now as decisive as the product itself.',
        'Financial inclusion has become a real driver of innovation and new business models.',
        'Collaboration replaces traditional competition as the way to scale.',
        'The new rules will be discussed live at the 20th ASOFOM National Convention (August 26–28, 2026, AVA Resort Cancun).',
      ],
    },

    /* ---------- Article sections ---------- */
    sections: [
      {
        id: 'cliente',
        h2: { es: 'El cliente cambió primero', en: 'The customer changed first' },
        paragraphs: {
          es: [
            'Los usuarios actuales esperan experiencias similares a las que reciben en otras industrias digitales: procesos simples, respuestas rápidas, atención personalizada y acceso desde cualquier dispositivo.',
            'Como consecuencia, las organizaciones financieras enfrentan un nuevo reto: adaptarse a un entorno donde la experiencia del cliente puede ser tan importante como el producto financiero en sí. Las instituciones que aún piden semanas para aprobar un crédito o que dependen de procesos 100 % presenciales están perdiendo relevancia frente a competidores que entregan respuestas en minutos.',
            'Para las SOFOMes, esto implica replantear cuatro frentes simultáneamente: onboarding digital, scoring alternativo, atención omnicanal y arquitectura de datos. Quien resuelva los cuatro primero, capturará la siguiente ola de crecimiento.',
          ],
          en: [],
        },
      },
      {
        id: 'inclusion',
        h2: { es: 'La inclusión financiera como motor de innovación', en: 'Financial inclusion as innovation engine' },
        paragraphs: {
          es: [
            'Uno de los cambios más relevantes ha sido la búsqueda de modelos que permitan ampliar el acceso a servicios financieros para personas y empresas que históricamente han permanecido fuera del sistema.',
            'La tecnología ha demostrado ser una herramienta poderosa para reducir barreras, optimizar procesos y desarrollar productos más accesibles para distintos segmentos de la población. El uso de información alternativa para evaluación crediticia, las cuentas digitales sin requisitos mínimos y los modelos de financiamiento embebido en plataformas no financieras están abriendo mercados que antes eran considerados no rentables.',
            'En México, el reto es escalar estos modelos sin sacrificar control de riesgo ni cumplimiento regulatorio — un equilibrio que solo se logra cuando producto, tecnología y regulatorio trabajan integrados.',
          ],
          en: [],
        },
      },
      {
        id: 'colaboracion',
        h2: { es: 'La colaboración reemplaza a la competencia tradicional', en: 'Collaboration replaces traditional competition' },
        paragraphs: {
          es: [
            'El crecimiento del ecosistema también ha impulsado nuevas formas de colaboración entre instituciones financieras, fintechs, proveedores tecnológicos y organismos del sector.',
            'Hoy, muchas de las soluciones más exitosas nacen de la combinación entre experiencia financiera, innovación tecnológica y conocimiento profundo de las necesidades de los usuarios. Los modelos de SOFOM-as-a-platform, los acuerdos de originación con fintechs, las APIs abiertas entre proveedores de scoring y la co-creación con burós de crédito son ejemplos de cómo la cadena de valor financiera se está reconfigurando.',
            'Más que competir por el mismo cliente con el mismo producto, las instituciones están descubriendo que el verdadero crecimiento viene de orquestar capacidades complementarias.',
          ],
          en: [],
        },
      },
      {
        id: 'conversacion-continua',
        h2: { es: 'La conversación continúa', en: 'The conversation continues' },
        paragraphs: {
          es: [
            'Comprender cómo evolucionan los modelos de negocio, qué tecnologías están marcando el rumbo del sector y cuáles serán las nuevas reglas de competencia es fundamental para los participantes del ecosistema financiero.',
            'Estos temas formarán parte de la conversación durante la 20ª Convención Nacional ASOFOM, donde líderes de la industria compartirán su visión sobre el futuro del sector.',
          ],
          en: [],
        },
      },
    ],

    /* ---------- CTA intermedio ---------- */
    midCta: {
      message: {
        es: 'Este cambio no se entiende solo desde la teoría. En la 20ª Convención Nacional ASOFOM, líderes del sector analizarán sus implicaciones, riesgos y oportunidades.',
        en: 'This change can\'t be understood from theory alone. At the 20th ASOFOM National Convention, sector leaders will analyze its implications, risks and opportunities.',
      },
    },

    /* ---------- La conversación en la Convención ---------- */
    conversation: {
      panel: { es: 'Nuevos Jugadores, Nuevas Reglas', en: 'New Players, New Rules' },
      subtitle: { es: 'El futuro del crédito y los servicios financieros', en: 'The future of credit and financial services' },
      why: {
        es: 'Este panel analizará cómo la innovación financiera, los nuevos participantes y las nuevas reglas de competencia están modificando el ecosistema, así como los desafíos que enfrentan las organizaciones para adaptarse.',
        en: 'This panel will analyze how financial innovation, new players and new competition rules are reshaping the ecosystem and the challenges organizations face to adapt.',
      },
      day: { es: 'Jueves 27 de agosto · 15:45 – 16:30 h', en: 'Thursday Aug 27 · 15:45 – 16:30' },
      location: 'Salón Peibo · AVA Resort Cancún',
      speakers: [
        { name: 'Carlos Marmolejo', role: { es: 'CEO & Cofundador · FINSUS', en: 'CEO & Co-founder · FINSUS' }, image: 'https://images.weserv.nl/?url=customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/x0dwb7sh_Carlos%20Marmolejo.jpg&w=400&h=400&fit=cover&a=top&q=80&output=webp' },
        { name: 'Jorge de Lara', role: { es: 'Presidente · Clara México', en: 'President · Clara Mexico' }, image: 'https://customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/2npqb64e_Jorge%20de%20Lara.jpg' },
      ],
      agendaUrl: '/agenda',
      registroUrl: '/registro',
    },

    /* ---------- FAQs (AEO) ---------- */
    faqs: [
      {
        q: { es: '¿Cómo está cambiando el sistema financiero mexicano?', en: 'How is Mexico\'s financial system changing?' },
        a: {
          es: 'El sistema financiero mexicano está cambiando por la entrada de fintechs, plataformas digitales, banca abierta, inteligencia artificial y nuevos modelos de colaboración entre instituciones tradicionales, SOFOMes y proveedores tecnológicos. El cliente final exige experiencias digitales rápidas y personalizadas, lo que está forzando a la industria a rediseñar sus productos, sus procesos de originación y su forma de competir.',
          en: 'Mexico\'s financial system is changing through fintechs, digital platforms, open banking, AI and new collaboration models among traditional institutions, SOFOMs and tech providers. End customers demand fast, personalized digital experiences, forcing the industry to redesign products, origination and competition.',
        },
      },
      {
        q: { es: '¿Qué papel tienen las fintechs en la transformación financiera?', en: 'What role do fintechs play in financial transformation?' },
        a: {
          es: 'Las fintechs actúan como aceleradoras del cambio: introducen experiencias digitales nativas, exploran segmentos desatendidos y usan datos alternativos para evaluar el riesgo. Más que reemplazar a las instituciones tradicionales, hoy colaboran con bancos, SOFOMes y proveedores tecnológicos para crear cadenas de valor más ágiles, accesibles y competitivas.',
          en: 'Fintechs accelerate change: they introduce digitally-native experiences, explore underserved segments and use alternative data for risk assessment.',
        },
      },
      {
        q: { es: '¿Cómo influye la inteligencia artificial en los servicios financieros?', en: 'How does AI influence financial services?' },
        a: {
          es: 'La inteligencia artificial influye en los servicios financieros optimizando la evaluación crediticia, detectando fraude en tiempo real, personalizando productos por cliente, automatizando atención y mejorando la gestión de cartera. Su impacto más profundo no es operativo: es estratégico, porque permite tomar decisiones de riesgo y oferta a una escala que antes era imposible.',
          en: 'AI influences financial services by optimizing credit scoring, detecting fraud in real time, personalizing products, automating support and improving portfolio management.',
        },
      },
      {
        q: { es: '¿Por qué la inclusión financiera es clave para el futuro del sector?', en: 'Why is financial inclusion key to the future?' },
        a: {
          es: 'La inclusión financiera es clave porque amplía el mercado total de la industria, reduce la desigualdad económica y crea nuevos espacios de innovación para SOFOMes, fintechs y bancos. Atender a personas y empresas históricamente fuera del sistema no es solo un objetivo social: es la mayor oportunidad de crecimiento sustentable para el sector financiero mexicano.',
          en: 'Financial inclusion is key because it expands the industry\'s total market, reduces inequality and creates new innovation spaces.',
        },
      },
    ],

    /* ---------- Related ---------- */
    relatedSlugs: ['del-pago-al-credito-quien-se-queda-con-la-relacion-del-cliente', 'el-sistema-financiero-que-mexico-necesita'],
  },

  {
    slug: 'el-sistema-financiero-que-mexico-necesita',
    categorySlug: 'tendencias-sofom',
    featured: false,
    publishedAt: '2026-07-02',
    readingMinutes: 5,
    author: { name: 'Equipo ASOFOM', role: 'Redacción institucional' },

    title: {
      es: 'El sistema financiero que México necesita: una conversación sobre el futuro',
      en: 'The financial system Mexico needs: a conversation about the future',
    },
    subtitle: {
      es: 'Un ecosistema más accesible, competitivo e innovador es la condición para que las empresas crezcan, los emprendedores construyan y el país genere desarrollo económico sostenido.',
      en: 'A more accessible, competitive and innovative ecosystem is the condition for companies to grow, entrepreneurs to build and the country to generate sustained economic development.',
    },

    seo: {
      metaTitle: 'El sistema financiero que México necesita | ASOFOM',
      metaDescription: 'Un análisis sobre la evolución del sistema financiero mexicano, el papel estratégico de las SOFOMes y la agenda que marcará la 20ª Convención Nacional ASOFOM 2026.',
      keyword: 'el sistema financiero que México necesita',
      secondaryKeywords: [
        'sistema financiero mexicano',
        'SOFOMes en México',
        'inclusión financiera pymes',
        'BIVA María Ariza',
        'ecosistema financiero México 2026',
        'ASOFOM Convención 2026',
      ],
    },

    cover: {
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1600&q=80&auto=format&fit=crop',
      alt: 'Ecosistema financiero mexicano: colaboración, innovación e inclusión para el desarrollo económico del país',
    },

    excerpt: {
      es: 'Hablar del sistema financiero no es hablar únicamente de bancos, crédito o inversión. Es hablar de las condiciones que permiten a las personas emprender, a las empresas crecer y al país generar desarrollo económico.',
      en: 'Talking about the financial system is not only about banks, credit or investment. It is about the conditions that allow people to start businesses, companies to grow and the country to generate economic development.',
    },

    summary60s: {
      es: [
        'El sistema financiero no es solo bancos y crédito: es la condición para que emprendedores, pymes y el país generen desarrollo económico.',
        'México tiene una oportunidad clave: construir un ecosistema financiero más accesible, competitivo e innovador.',
        'Colaboración entre instituciones, regulación pro-innovación y acceso ampliado al financiamiento son las tres palancas.',
        'Las SOFOMes juegan un papel estratégico: cercanía con pymes, soluciones especializadas y ampliación de la inclusión financiera.',
        'El reto ya no es hacer crecer al sector — es construir uno que responda mejor a las necesidades del país.',
      ],
      en: [
        'The financial system is not just banks and credit — it is the condition for development.',
        'Mexico has a key opportunity: build a more accessible, competitive and innovative ecosystem.',
        'Collaboration, pro-innovation regulation and expanded financing access are the three levers.',
        'SOFOMs play a strategic role connecting SMEs with financing.',
        'The challenge is no longer to grow the sector — it is to build one that better serves the country.',
      ],
    },

    sections: [
      {
        id: 'mas-alla-de-los-bancos',
        h2: { es: 'Más allá de bancos, crédito o inversión', en: 'Beyond banks, credit or investment' },
        paragraphs: {
          es: [
            'Hablar del sistema financiero no es hablar únicamente de bancos, crédito o inversión. Es hablar de las condiciones que permiten a las personas emprender, a las empresas crecer y al país generar desarrollo económico.',
            'Hoy, México enfrenta una oportunidad importante: construir un ecosistema financiero más accesible, competitivo e innovador, capaz de responder a las necesidades de una economía que evoluciona a gran velocidad.',
          ],
          en: [],
        },
      },
      {
        id: 'tres-palancas',
        h2: { es: 'Las tres palancas del cambio', en: 'The three levers of change' },
        paragraphs: {
          es: [
            'Para lograrlo, es indispensable fortalecer la colaboración entre instituciones, promover un entorno regulatorio que impulse la innovación y ampliar el acceso a fuentes de financiamiento para empresas de todos los tamaños.',
            'Un sistema financiero sólido moviliza capital, pero también genera confianza, fomenta la inversión y acelera el crecimiento. Cada una de estas palancas se refuerza con las demás: sin regulación adecuada la innovación se estanca; sin colaboración institucional el acceso se fragmenta; sin acceso financiero la economía real no crece.',
          ],
          en: [],
        },
      },
      {
        id: 'papel-sofomes',
        h2: { es: 'El papel estratégico de las SOFOMes', en: 'The strategic role of SOFOMs' },
        paragraphs: {
          es: [
            'En este contexto, las SOFOMes desempeñan un papel estratégico. Su cercanía con las pequeñas y medianas empresas, así como su capacidad para desarrollar soluciones especializadas, las convierte en actores clave para ampliar la inclusión financiera y atender segmentos que requieren modelos más flexibles.',
            'Son las que llegan donde la banca tradicional no llega, y las que están construyendo la infraestructura de crédito para el México productivo del futuro.',
          ],
          en: [],
        },
      },
      {
        id: 'el-nuevo-reto',
        h2: { es: 'El nuevo reto: construir, no solo crecer', en: 'The new challenge: to build, not just grow' },
        paragraphs: {
          es: [
            'El reto ya no es únicamente hacer crecer al sector financiero, sino construir uno que responda mejor a las necesidades del país y contribuya al desarrollo sostenible de la economía.',
            'Esta reflexión será parte de la 20ª Convención Nacional ASOFOM, donde se analizarán los desafíos, oportunidades y decisiones que marcarán el rumbo del ecosistema financiero mexicano.',
          ],
          en: [],
        },
      },
    ],

    midCta: {
      message: {
        es: 'La transformación del sistema financiero mexicano no se resuelve en abstracto. En la 20ª Convención Nacional ASOFOM, líderes del sector pondrán sobre la mesa las decisiones que definirán la próxima década.',
        en: 'The transformation of the Mexican financial system is not solved in the abstract. At the 20th ASOFOM National Convention, sector leaders will put on the table the decisions that will define the next decade.',
      },
    },

    conversation: {
      panel: { es: 'El Sistema Financiero que México Necesita: Una conversación sin filtro', en: 'The Financial System Mexico Needs: An unfiltered conversation' },
      subtitle: { es: 'Un espacio para analizar desafíos, oportunidades y decisiones', en: 'A space to analyze challenges, opportunities and decisions' },
      why: {
        es: 'Un espacio para analizar los desafíos, oportunidades y decisiones que marcarán el rumbo del ecosistema financiero mexicano. Una conversación sin filtro con dos de las voces más influyentes del sistema financiero y empresarial del país.',
        en: 'A space to analyze the challenges, opportunities and decisions that will shape the direction of the Mexican financial ecosystem.',
      },
      day: { es: 'Jueves 27 de agosto · 11:00 – 11:45 h', en: 'Thursday Aug 27 · 11:00 – 11:45' },
      location: 'Salón Peibo · AVA Resort Cancún',
      speakers: [
        { name: 'María Ariza', role: { es: 'CEO · BIVA', en: 'CEO · BIVA' }, image: 'https://customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/5ok7nqja_Maria%20Ariza.jpg' },
        { name: 'Co-ponente · Identidad reservada', role: { es: 'Una de las empresarias más influyentes de México · Empresaria y autoridad del ecosistema económico nacional (próxima a revelar)', en: 'One of Mexico\'s most influential businesswomen (to be revealed)' }, incognito: true },
      ],
      agendaUrl: '/agenda',
      registroUrl: '/registro',
    },

    faqs: [
      {
        q: { es: '¿Por qué el sistema financiero necesita evolucionar?', en: 'Why does the financial system need to evolve?' },
        a: {
          es: 'Porque la economía mexicana avanza a gran velocidad y demanda condiciones para que personas y empresas puedan emprender, crecer y financiarse. Un sistema financiero anticuado limita el potencial del país. La evolución implica más accesibilidad, más competencia, más innovación y una regulación que acompañe — no que frene — el cambio.',
          en: 'Because the Mexican economy is moving fast and demands conditions for people and companies to grow and finance themselves. An outdated financial system limits the country\'s potential.',
        },
      },
      {
        q: { es: '¿Qué papel juegan las SOFOMes en el nuevo sistema financiero?', en: 'What role do SOFOMs play in the new financial system?' },
        a: {
          es: 'Las SOFOMes son actores estratégicos: su cercanía con pymes y su capacidad de desarrollar soluciones especializadas las convierte en canal clave para ampliar la inclusión financiera y atender segmentos que la banca tradicional no cubre. Son el motor de financiamiento para el México productivo.',
          en: 'SOFOMs are strategic players: their closeness to SMEs and their capacity to develop specialized solutions makes them a key channel to expand financial inclusion.',
        },
      },
      {
        q: { es: '¿Qué se requiere para construir un mejor sistema financiero en México?', en: 'What is needed to build a better financial system in Mexico?' },
        a: {
          es: 'Se requiere colaboración entre instituciones, regulación pro-innovación y acceso ampliado al financiamiento. Cuando estos tres factores se combinan, el sistema financiero moviliza capital, genera confianza, fomenta la inversión y acelera el crecimiento económico sostenible.',
          en: 'Collaboration between institutions, pro-innovation regulation and expanded access to financing. When these three factors combine, the system mobilizes capital and drives sustainable growth.',
        },
      },
      {
        q: { es: '¿Quién liderará esta conversación en la Convención ASOFOM 2026?', en: 'Who will lead this conversation at ASOFOM 2026?' },
        a: {
          es: 'María Ariza, CEO de BIVA, en conjunto con una de las empresarias más influyentes de México — reconocida autoridad del ecosistema económico nacional cuya identidad se revelará próximamente — encabezarán "El Sistema Financiero que México Necesita: Una conversación sin filtro" el jueves 27 de agosto en el Salón Peibo del AVA Resort Cancún.',
          en: 'María Ariza, CEO of BIVA, together with one of Mexico\'s most influential businesswomen (to be revealed), will lead the conversation at AVA Resort Cancún.',
        },
      },
    ],

    relatedSlugs: ['como-esta-cambiando-el-sistema-financiero-mexicano', 'esg-de-requisito-a-ventaja-competitiva'],
  },

  {
    slug: 'esg-de-requisito-a-ventaja-competitiva',
    categorySlug: 'sostenibilidad-asg',
    featured: false,
    publishedAt: '2026-07-08',
    readingMinutes: 5,
    author: { name: 'Equipo ASOFOM', role: 'Redacción institucional' },

    title: {
      es: 'ESG: de requisito regulatorio a ventaja competitiva para acceder al financiamiento',
      en: 'ESG: from regulatory requirement to competitive advantage in accessing financing',
    },
    subtitle: {
      es: 'Los criterios ambientales, sociales y de gobernanza dejaron de ser un requisito de cumplimiento para convertirse en un factor determinante para acceder a capital de largo plazo y mejores condiciones de financiamiento.',
      en: 'Environmental, social and governance criteria are no longer a compliance requirement — they are a decisive factor to access long-term capital and better financing conditions.',
    },

    seo: {
      metaTitle: 'ESG: de requisito a ventaja competitiva | ASOFOM',
      metaDescription: 'Cómo los criterios ESG están redefiniendo el acceso al financiamiento en México. Análisis para SOFOMes y el sector financiero rumbo a la 20 Convención Nacional ASOFOM 2026.',
      keyword: 'ESG y financiamiento en México',
      secondaryKeywords: [
        'criterios ESG SOFOMes',
        'sostenibilidad y ASG en el sistema financiero',
        'financiamiento sostenible México',
        'agenda ESG Convención ASOFOM',
        'inversión responsable México',
        'BID Invest ESG',
      ],
    },

    cover: {
      image: 'https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?w=1600&q=80&auto=format&fit=crop',
      alt: 'Naturaleza y crecimiento sostenible: ESG como ventaja competitiva para el acceso al financiamiento en México',
    },

    excerpt: {
      es: 'Durante años, los criterios ambientales, sociales y de gobernanza fueron vistos como cumplimiento. Hoy, cada vez más inversionistas e instituciones financieras los usan para evaluar riesgos, generar confianza y canalizar capital hacia organizaciones mejor preparadas para el futuro.',
      en: 'For years, ESG criteria were seen as compliance. Today, investors and financial institutions use them to assess risk, build trust and channel capital to organizations better prepared for the future.',
    },

    summary60s: {
      es: [
        'Los criterios ESG dejaron de ser un requisito de cumplimiento: hoy definen el acceso al capital.',
        'Integrar sostenibilidad, gobernanza y gestión responsable abre mejores condiciones de financiamiento.',
        'México puede fortalecer su competitividad atrayendo capital de largo plazo con organizaciones más transparentes y resilientes.',
        'Las SOFOMes tienen un papel estratégico: cercanía con sectores productivos y capacidad de promover prácticas ESG a lo largo de la cadena.',
        'El panel "De la oportunidad al capital" con Armando Simón (BID Invest) y Julio César Martínez (Fondo de Fondos) abordará estas tendencias en la 20ª Convención ASOFOM.',
      ],
      en: [
        'ESG criteria are no longer compliance — they define capital access.',
        'Integrating sustainability, governance and responsible management unlocks better financing conditions.',
        'Mexico can attract long-term capital through more transparent, resilient organizations.',
        'SOFOMs play a strategic role: close to productive sectors and able to drive ESG practices across the chain.',
        'The panel "From Opportunity to Capital" with Armando Simón (IDB Invest) and Julio César Martínez (Fondo de Fondos) will address these trends at the 20th ASOFOM Convention.',
      ],
    },

    sections: [
      {
        id: 'de-cumplimiento-a-decision',
        h2: { es: 'De cumplimiento a decisión de capital', en: 'From compliance to a capital decision' },
        paragraphs: {
          es: [
            'Durante años, los criterios ambientales, sociales y de gobernanza (ESG) fueron vistos principalmente como un requisito de cumplimiento. Hoy, el panorama ha cambiado: cada vez más inversionistas e instituciones financieras los consideran un elemento clave para evaluar riesgos, generar confianza y canalizar capital hacia organizaciones mejor preparadas para el futuro.',
            'Esta evolución está redefiniendo la forma en que las empresas acceden al financiamiento. Integrar prácticas de sostenibilidad, fortalecer la gobernanza y demostrar una gestión responsable responde a expectativas regulatorias, pero también se traduce en mayores oportunidades de inversión y mejores condiciones de financiamiento.',
          ],
          en: [],
        },
      },
      {
        id: 'oportunidad-mexico',
        h2: { es: 'Una oportunidad estratégica para México', en: 'A strategic opportunity for Mexico' },
        paragraphs: {
          es: [
            'Para México, esta tendencia representa una oportunidad importante. A medida que los mercados financieros incorporan criterios ESG en sus decisiones, contar con organizaciones más transparentes, resilientes y comprometidas con el desarrollo sostenible puede fortalecer la competitividad del país y atraer capital de largo plazo.',
            'La sofisticación de los inversionistas globales exige más que buenos resultados financieros: pide trazabilidad, evidencia y una visión clara de cómo la organización gestiona sus impactos y riesgos ambientales y sociales.',
          ],
          en: [],
        },
      },
      {
        id: 'papel-sofomes',
        h2: { es: 'El papel estratégico de las SOFOMes', en: 'The strategic role of SOFOMs' },
        paragraphs: {
          es: [
            'Las SOFOMes también tienen un papel estratégico en esta transformación. Su cercanía con distintos sectores productivos les permite impulsar modelos de financiamiento que generen valor económico, al tiempo que promueven prácticas responsables entre sus clientes y aliados.',
            'Al integrar criterios ESG en su originación, políticas de crédito y gobierno corporativo, las SOFOMes no solo mejoran su propio perfil de riesgo: se convierten en agentes activos de un mercado más responsable, competitivo y atractivo para el capital internacional.',
          ],
          en: [],
        },
      },
      {
        id: 'preguntas-clave',
        h2: { es: 'La pregunta clave para el sector', en: 'The key question for the sector' },
        paragraphs: {
          es: [
            '¿Cómo pueden las organizaciones convertir los retos regulatorios en una ventaja competitiva para acceder a nuevas fuentes de financiamiento?',
            'Esta conversación formará parte de la 20 Convención Nacional ASOFOM durante el panel "De la oportunidad al capital: cómo conectar a México con la inversión internacional", donde Armando Simón, Oficial Líder de Inversiones para el Sector Financiero en México y Centroamérica de BID Invest; y Julio César Martínez, Head de Private Equity de Fondo de Fondos, analizarán las tendencias regulatorias y las oportunidades de financiamiento vinculadas a los criterios ESG.',
          ],
          en: [],
        },
      },
    ],

    midCta: {
      message: {
        es: 'La agenda ESG ya no se resuelve en el reporte anual: se decide en la mesa de inversionistas. En la 20ª Convención Nacional ASOFOM, líderes del capital institucional discutirán las nuevas reglas del financiamiento sostenible.',
        en: 'The ESG agenda is no longer solved in the annual report — it is decided at the investor\'s table. At the 20th ASOFOM National Convention, leaders of institutional capital will discuss the new rules of sustainable finance.',
      },
    },

    conversation: {
      panel: { es: 'De la oportunidad al capital: cómo conectar a México con la inversión internacional', en: 'From Opportunity to Capital: connecting Mexico with international investment' },
      subtitle: { es: 'Tendencias regulatorias, ESG y financiamiento internacional', en: 'Regulatory trends, ESG and international financing' },
      why: {
        es: 'Un espacio para analizar cómo los criterios ESG, la sostenibilidad y la gobernanza están reconfigurando las decisiones de inversión, y qué necesita el sector financiero mexicano para atraer capital de largo plazo.',
        en: 'A space to analyze how ESG, sustainability and governance are reshaping investment decisions, and what Mexico\'s financial sector needs to attract long-term capital.',
      },
      day: { es: 'Viernes 28 de agosto · 11:45 – 12:30 h', en: 'Friday Aug 28 · 11:45 – 12:30' },
      location: 'Salón Peibo · AVA Resort Cancún',
      speakers: [
        { name: 'Armando Simón', role: { es: 'Oficial Líder de Inversiones · Sector Financiero · México y Centroamérica · BID Invest', en: 'Lead Investment Officer · Financial Sector · Mexico & Central America · IDB Invest' }, image: 'https://customer-assets.emergentagent.com/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/ww01i8md_Armando%20Simo%CC%81n.png' },
        { name: 'Julio César Martínez', role: { es: 'Head de Private Equity · Fondo de Fondos', en: 'Head of Private Equity · Fondo de Fondos' }, image: 'https://images.weserv.nl/?url=customer-assets-lxgj4vgw.emergentagent.net/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/9plzvie8_image005.jpg%20%281%29.jpeg&w=400&h=400&fit=cover&a=top&q=80&output=webp' },
      ],
      agendaUrl: '/agenda',
      registroUrl: '/registro',
    },

    faqs: [
      {
        q: { es: '¿Por qué los criterios ESG son importantes para acceder al financiamiento?', en: 'Why are ESG criteria important for accessing financing?' },
        a: {
          es: 'Porque los inversionistas e instituciones financieras utilizan los criterios ESG para evaluar el riesgo, la resiliencia y la calidad de gestión de las organizaciones. Empresas que integran sostenibilidad, gobernanza y responsabilidad social reciben mejores condiciones de financiamiento, acceden a más fuentes de capital y son más atractivas para el inversionista institucional de largo plazo.',
          en: 'Investors and financial institutions use ESG criteria to assess risk, resilience and management quality. Companies that integrate sustainability, governance and social responsibility get better financing conditions and access more capital sources.',
        },
      },
      {
        q: { es: '¿Qué pueden hacer las SOFOMes para adoptar criterios ESG?', en: 'What can SOFOMs do to adopt ESG criteria?' },
        a: {
          es: 'Las SOFOMes pueden integrar ESG en sus políticas de crédito y originación, fortalecer su gobierno corporativo, medir y reportar sus impactos, y promover prácticas responsables entre sus clientes. Al hacerlo, mejoran su perfil de riesgo, acceden a fondeo institucional más sofisticado y se convierten en agentes de transformación de la cadena productiva mexicana.',
          en: 'SOFOMs can integrate ESG into credit and origination policies, strengthen corporate governance, measure and report impacts, and promote responsible practices across their portfolios.',
        },
      },
      {
        q: { es: '¿Cómo puede México aprovechar la agenda ESG para atraer capital?', en: 'How can Mexico leverage the ESG agenda to attract capital?' },
        a: {
          es: 'México puede posicionarse como destino atractivo para el capital de largo plazo construyendo organizaciones más transparentes, resilientes y alineadas con las mejores prácticas internacionales de sostenibilidad. La adopción sistémica de ESG en el sector financiero y en la cadena productiva aumenta la competitividad país y desbloquea fuentes de financiamiento hasta ahora subutilizadas.',
          en: 'Mexico can position itself as an attractive destination for long-term capital by building more transparent, resilient organizations aligned with international sustainability best practices.',
        },
      },
      {
        q: { es: '¿Quién liderará esta conversación en la 20 Convención Nacional ASOFOM?', en: 'Who will lead this conversation at the 20th ASOFOM Convention?' },
        a: {
          es: 'El panel "De la oportunidad al capital: cómo conectar a México con la inversión internacional" será encabezado por Armando Simón, Oficial Líder de Inversiones para el Sector Financiero en México y Centroamérica de BID Invest; y Julio César Martínez, Head de Private Equity de Fondo de Fondos. Ambos analizarán tendencias regulatorias, criterios ESG y oportunidades reales de financiamiento internacional para México.',
          en: 'The panel "From Opportunity to Capital" will be led by Armando Simón, Lead Investment Officer for the Financial Sector in Mexico & Central America at IDB Invest, and Julio César Martínez, Head of Private Equity at Fondo de Fondos.',
        },
      },
    ],

    relatedSlugs: ['del-pago-al-credito-quien-se-queda-con-la-relacion-del-cliente', 'como-esta-cambiando-el-sistema-financiero-mexicano'],
  },

  {
    slug: 'del-pago-al-credito-quien-se-queda-con-la-relacion-del-cliente',
    categorySlug: 'innovacion-financiera',
    featured: false,
    publishedAt: '2026-07-08',
    readingMinutes: 5,
    author: { name: 'Equipo ASOFOM', role: 'Redacción institucional' },

    title: {
      es: 'Del pago al crédito: la nueva competencia por la relación con el cliente',
      en: 'From payment to credit: the new competition for the customer relationship',
    },
    subtitle: {
      es: 'Los ecosistemas financieros integran pagos, crédito y administración financiera en una misma experiencia. La verdadera pregunta ya no es quién ofrece el mejor crédito, sino quién construye una relación de largo plazo con el cliente.',
      en: 'Financial ecosystems integrate payments, credit and financial management into a single experience. The real question is no longer who offers the best credit, but who builds a long-term relationship with the customer.',
    },

    seo: {
      metaTitle: 'Del pago al crédito: la relación con el cliente | ASOFOM',
      metaDescription: 'Los ecosistemas financieros están redefiniendo la competencia: pagos, crédito y datos en una sola experiencia. Carlos López Moctezuma (Bancoppel) y Enrique Díez-Canedo (Kapital) lo analizan en la 20ª Convención Nacional ASOFOM.',
      keyword: 'ecosistemas financieros y relación con el cliente',
      secondaryKeywords: [
        'ecosistemas financieros en México',
        'pagos digitales y crédito',
        'experiencia del cliente financiero',
        'Kapital fintech',
        'NetPay pagos',
        'ASOFOM Convención 2026',
      ],
    },

    cover: {
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1600&q=80&auto=format&fit=crop',
      alt: 'Ecosistemas financieros: integración de pagos, crédito y servicios en una sola experiencia para el cliente',
    },

    excerpt: {
      es: 'Durante años, los servicios financieros se ofrecieron de manera independiente: una institución para pagar, otra para solicitar crédito y otra más para administrar las finanzas. Hoy, esa dinámica está cambiando.',
      en: 'For years, financial services were offered independently: one institution to pay, another to request credit and another to manage finances. Today, that dynamic is changing.',
    },

    summary60s: {
      es: [
        'Los ecosistemas financieros integran pagos, crédito, administración financiera y otros servicios en una misma experiencia.',
        'La competencia ya no se centra en el mejor producto, sino en construir experiencias simples, personalizadas y conectadas.',
        'Quien acompaña al cliente a lo largo de todo su recorrido financiero conoce mejor sus necesidades y genera más valor.',
        'Para las SOFOMes, esta evolución abre oportunidades de alianzas estratégicas y nuevas capacidades digitales.',
        'Carlos López Moctezuma (Bancoppel) y Enrique Díez-Canedo (Kapital) debatirán quién se queda con la relación del cliente en la 20ª Convención Nacional ASOFOM.',
      ],
      en: [
        'Financial ecosystems integrate payments, credit, financial management and other services into a single experience.',
        'Competition is no longer about the best product, but about simple, personalized and connected experiences.',
        'Whoever accompanies the customer throughout their financial journey knows their needs better and generates more value.',
        'For SOFOMs, this evolution opens opportunities for strategic alliances and new digital capabilities.',
        'Carlos López Moctezuma (Bancoppel) and Enrique Díez-Canedo (Kapital) will debate who keeps the customer relationship at the 20th ASOFOM National Convention.',
      ],
    },

    sections: [
      {
        id: 'servicios-integrados',
        h2: { es: 'De servicios independientes a ecosistemas integrados', en: 'From independent services to integrated ecosystems' },
        paragraphs: {
          es: [
            'Durante años, los servicios financieros se ofrecieron de manera independiente: una institución para pagar, otra para solicitar crédito y otra más para administrar las finanzas. Hoy, esa dinámica está cambiando.',
            'Los ecosistemas financieros integran pagos, crédito, administración financiera y otros servicios en una misma experiencia, permitiendo a empresas y usuarios resolver múltiples necesidades desde una sola plataforma.',
          ],
          en: [],
        },
      },
      {
        id: 'conocer-al-cliente',
        h2: { es: 'Quien conoce mejor al cliente, genera más valor', en: 'Whoever knows the customer better, generates more value' },
        paragraphs: {
          es: [
            'La competencia ya no se centra únicamente en ofrecer el mejor producto financiero, sino en construir experiencias simples, personalizadas y conectadas.',
            'Las organizaciones que acompañan al cliente a lo largo de todo su recorrido financiero pueden comprender mejor sus necesidades, anticiparse a ellas y ofrecer soluciones cada vez más relevantes. Esa cercanía fortalece la confianza y abre nuevas oportunidades de crecimiento.',
          ],
          en: [],
        },
      },
      {
        id: 'nuevas-reglas',
        h2: { es: 'Los ecosistemas financieros están redefiniendo las reglas', en: 'Financial ecosystems are redefining the rules' },
        paragraphs: {
          es: [
            'La integración entre pagos, crédito, tecnología y servicios financieros está impulsando nuevos modelos de negocio basados en colaboración, datos e innovación.',
            'Para las SOFOMes, esta evolución representa una oportunidad para desarrollar alianzas estratégicas, incorporar nuevas capacidades digitales y fortalecer su propuesta de valor en un mercado cada vez más competitivo.',
          ],
          en: [],
        },
      },
      {
        id: 'la-pregunta-clave',
        h2: { es: 'La pregunta ya no es quién ofrece el mejor crédito', en: 'The question is no longer who offers the best credit' },
        paragraphs: {
          es: [
            'La verdadera pregunta es: ¿quién será capaz de construir una relación de largo plazo con el cliente?',
            'Ese será el eje del panel "Del Pago al Crédito: ¿Quién se Queda con la Relación del Cliente?", que se llevará a cabo durante nuestra 20° Convención Nacional ASOFOM. En esta conversación, Carlos López Moctezuma, Director General de Bancoppel y Servicios Financieros Grupo Coppel, y Enrique Díez-Canedo, Head Revenue Growth de Kapital Grupo Financiero, con la moderación del Dr. Enrique Presburger, compartirán su visión sobre la evolución de los ecosistemas financieros y la batalla por ofrecer una mejor experiencia al cliente en un entorno cada vez más digital.',
          ],
          en: [],
        },
      },
    ],

    midCta: {
      message: {
        es: 'La batalla por la relación con el cliente ya comenzó. En la 20ª Convención Nacional ASOFOM, los líderes de Kapital y NetPay pondrán sobre la mesa quién se queda con ella.',
        en: 'The battle for the customer relationship has already begun. At the 20th ASOFOM National Convention, the leaders of Kapital and NetPay will put on the table who keeps it.',
      },
    },

    conversation: {
      panel: { es: 'Del Pago al Crédito: ¿Quién se Queda con la Relación del Cliente?', en: 'From Payment to Credit: Who Keeps the Customer Relationship?' },
      subtitle: { es: 'La evolución de los ecosistemas financieros y la batalla por la experiencia del cliente', en: 'The evolution of financial ecosystems and the battle for customer experience' },
      why: {
        es: 'Este panel analizará cómo la integración de pagos, crédito y servicios financieros está redefiniendo la competencia, y quién será capaz de construir la relación de largo plazo con el cliente en un entorno cada vez más digital.',
        en: 'This panel will analyze how the integration of payments, credit and financial services is redefining competition, and who will be able to build the long-term customer relationship in an increasingly digital environment.',
      },
      day: { es: 'Viernes 28 de agosto · 10:45 – 11:30 h', en: 'Friday Aug 28 · 10:45 – 11:30' },
      location: 'Salón Peibo · AVA Resort Cancún',
      speakers: [
        { name: 'Carlos López Moctezuma', role: { es: 'Director General · Bancoppel y Servicios Financieros Grupo Coppel', en: 'CEO · Bancoppel & Financial Services Grupo Coppel' }, image: 'https://images.weserv.nl/?url=customer-assets-lxgj4vgw.emergentagent.net/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/jgubhi9t_CLM.png&w=400&h=400&fit=cover&a=top&q=80&output=webp' },
        { name: 'Enrique Díez-Canedo', role: { es: 'Head Revenue Growth · Kapital Grupo Financiero', en: 'Head of Revenue Growth · Kapital Grupo Financiero' }, image: 'https://images.weserv.nl/?url=customer-assets-lxgj4vgw.emergentagent.net/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/naq1la69_Enrique%20Di%CC%81ez-Canedo.png&w=400&h=400&fit=cover&a=top&q=80&output=webp' },
        { name: 'Dr. Enrique Presburger', role: { es: 'Moderador · CEO · Factor Exprés · Expresidente Nacional de ASOFOM', en: 'Moderator · CEO · Factor Exprés · Former ASOFOM National President' }, image: 'https://images.weserv.nl/?url=customer-assets-lxgj4vgw.emergentagent.net/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/4ngugriw_Enrique%20Presburger%20ASOFOM%20Presidente%20Nacional.jpg&w=600&h=600&fit=cover&a=top&q=80&output=webp' },
      ],
      agendaUrl: '/agenda',
      registroUrl: '/registro',
    },

    faqs: [
      {
        q: { es: '¿Qué es un ecosistema financiero integrado?', en: 'What is an integrated financial ecosystem?' },
        a: {
          es: 'Es un modelo en el que pagos, crédito, administración financiera y otros servicios se ofrecen dentro de una misma experiencia o plataforma. En lugar de acudir a una institución distinta para cada necesidad, empresas y usuarios resuelven múltiples necesidades desde un solo lugar, con datos conectados y experiencias personalizadas.',
          en: 'It is a model where payments, credit, financial management and other services are offered within a single experience or platform, allowing companies and users to solve multiple needs from one place.',
        },
      },
      {
        q: { es: '¿Por qué la relación con el cliente es el nuevo campo de batalla financiero?', en: 'Why is the customer relationship the new financial battleground?' },
        a: {
          es: 'Porque quien acompaña al cliente a lo largo de todo su recorrido financiero conoce mejor sus necesidades, puede anticiparse a ellas y ofrecer soluciones más relevantes. Esa cercanía genera confianza, datos y oportunidades de crecimiento que ningún producto aislado puede igualar. La competencia ya no es por la mejor tasa: es por la relación de largo plazo.',
          en: 'Because whoever accompanies the customer throughout their financial journey knows their needs better, can anticipate them and offer more relevant solutions. Competition is no longer about the best rate — it is about the long-term relationship.',
        },
      },
      {
        q: { es: '¿Qué oportunidades abren los ecosistemas financieros para las SOFOMes?', en: 'What opportunities do financial ecosystems open for SOFOMs?' },
        a: {
          es: 'Las SOFOMes pueden desarrollar alianzas estratégicas con fintechs y plataformas de pagos, incorporar nuevas capacidades digitales y fortalecer su propuesta de valor. Integrarse a ecosistemas les permite acceder a más datos del cliente, mejorar su originación y competir en experiencia, no solo en producto.',
          en: 'SOFOMs can develop strategic alliances with fintechs and payment platforms, incorporate new digital capabilities and strengthen their value proposition by competing on experience, not just product.',
        },
      },
      {
        q: { es: '¿Quién liderará esta conversación en la 20 Convención Nacional ASOFOM?', en: 'Who will lead this conversation at the 20th ASOFOM Convention?' },
        a: {
          es: 'El panel "Del Pago al Crédito: ¿Quién se Queda con la Relación del Cliente?" será encabezado por Carlos López Moctezuma, Director General de Bancoppel y Servicios Financieros Grupo Coppel, y Enrique Díez-Canedo, Head Revenue Growth de Kapital Grupo Financiero, con la moderación del Dr. Enrique Presburger, el viernes 28 de agosto de 10:45 a 11:30 h en el Salón Peibo del AVA Resort Cancún.',
          en: 'The panel will be led by Carlos López Moctezuma, CEO of Bancoppel & Financial Services Grupo Coppel, and Enrique Díez-Canedo, Head of Revenue Growth at Kapital Grupo Financiero, moderated by Dr. Enrique Presburger, on Friday, August 28 from 10:45 to 11:30 at Salón Peibo, AVA Resort Cancún.',
        },
      },
    ],

    relatedSlugs: ['como-esta-cambiando-el-sistema-financiero-mexicano', 'el-sistema-financiero-que-mexico-necesita'],
  },
];

/* Helpers */
export const getArticleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
export const getCategoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const getFeaturedArticle = () => ARTICLES.find((a) => a.featured) || ARTICLES[0];
export const getArticlesByCategory = (slug) => slug ? ARTICLES.filter((a) => a.categorySlug === slug) : ARTICLES;
